export default "__VITE_ASSET__SLsPZEig__"